import { useEffect, useState } from "react";
import { InTheHeadlightProps } from "./types";
import { getITH } from "../../dreamCar-service";

const InTheHeadlight = ({ prizeCategory, classNames }: { prizeCategory: string; classNames: string }) => {
  const [mobileImage, setMobileImage] = useState<string>("");
  const [desktopImage, setDesktopImage] = useState<string>("");
  const [clickURL, setClickURL] = useState("");
  useEffect(() => {
    (async () => {
      const response = await getITH(prizeCategory);
      const { ithDesktopImage, ithMobileImage, clickThroughUrl } = (await response.json()) as InTheHeadlightProps;
      setMobileImage(ithMobileImage);
      setDesktopImage(ithDesktopImage);
      setClickURL(clickThroughUrl);
    })();
  }, []);

  const onITHClick = () => {
    location.href = clickURL;
  };

  return (
    <div className={`${classNames} cursor-pointer`} onClick={onITHClick}>
      <picture>
        {mobileImage && <source media="(max-width: 600px)" srcSet={mobileImage} />}
        {desktopImage && <img src={desktopImage} alt="In The Headlight Image" className="lg:rounded-t-2xl" />}
      </picture>
    </div>
  );
};

export default InTheHeadlight;
